<template>
  <div class="jiesuan">
    <ul>
      <li>{{detailsTypeName}}</li>
    </ul>
    <div class="select">
      <el-button type="primary" @click="centerDialogVisible=true">结算</el-button>
      <el-select placeholder="请选择" v-model="select">
        <el-option v-for="item in selsectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" @click="toPath">创建</el-button>
    </div>
    <el-dialog title="结算" :visible.sync="centerDialogVisible" center width="850px" :modal-append-to-body='false'>
      <el-table empty-text="暂无数据" :data="detailLists" class="mgt15" border @expand-change="toggleRowExpansion" :expand-row-keys="expands" :row-key="getRowKeys">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item>
                <ul class="area">
                  <li v-if="mongeyObj.totalFee">
                    <p>报价</p>
                    <div>
                      <p>整体报价:<span>{{mongeyObj.totalFee || 0}} {{mongeyObj.currency}}</span></p>
                      <p v-if="caseid != 800">医疗垫付:<span>{{mongeyObj.medicFee || 0}} {{mongeyObj.currency}}</span></p>
                      <p v-if="caseid != 800">案件费用:<span>{{mongeyObj.caseFee || 0}} {{mongeyObj.currency}}</span></p>
                      <p>救援费用:<span>{{mongeyObj.rescueFee || 0}} {{mongeyObj.currency}}</span></p>
                    </div>
                  </li>
                  <li v-if="shijiMoney.totalFee">
                    <p>实际费用</p>
                    <div>
                      <p>整体报价:<span>{{shijiMoney.totalFee || 0}} {{shijiMoney.currency}}</span></p>
                      <p v-if="caseid != 800">医疗垫付:<span>{{shijiMoney.medicFee || 0}} {{shijiMoney.currency}}</span></p>
                      <p v-if="caseid != 800">案件费用:<span>{{shijiMoney.caseFee || 0}} {{shijiMoney.currency}}</span></p>
                      <p>救援费用:<span>{{shijiMoney.rescueFee || 0}} {{shijiMoney.currency}}</span></p>
                      <p>其他费用:<span>{{shijiMoney.otherFee || 0}} {{shijiMoney.currency}}</span></p>
                      <p class="long">其他费用说明:<span style="color: #999;">{{setTxt(shijiMoney.otherFeeDesc)}}</span></p>
                    </div>
                  </li>
                  <li v-if="afterMoney.totalFee">
                    <p>应收保险公司费用</p>
                    <div>
                      <p>整体报价:<span>{{afterMoney.totalFee || 0}} {{afterMoney.currency}}</span></p>
                      <p>医疗垫付:<span>{{afterMoney.medicFee || 0}} {{afterMoney.currency}}</span></p>
                      <p>救援费用:<span>{{afterMoney.rescueFee || 0}} {{afterMoney.currency}}</span></p>
                      <p>其他费用:<span>{{afterMoney.otherFee || 0}} {{afterMoney.currency}}</span></p>
                    </div>
                  </li>
                </ul>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="obj.incidentTypeStr" label="服务项"></el-table-column>
        <el-table-column label="服务开始时间">
          <template slot-scope="scope" v-if="scope.row.obj2">
            {{setTime(scope.row.obj2[0].dict.createAt)}}
          </template>
        </el-table-column>
        <el-table-column label="服务时长">
          <template slot-scope="scope">
            {{timeToStr(scope.row.obj.obj.lastCheckPtsTs , scope.row.obj.obj.reportTs, scope.row.obj.obj.caseState)}}
          </template>
        </el-table-column>
        <el-table-column label="费用">
          <template slot-scope="scope" v-if="scope.row.obj.feelst">
            {{scope.row.obj.feelst.length != 0?scope.row.obj.feelst[0].totalFee:0}}元
          </template>
        </el-table-column>
        <el-table-column label="当前状态">
          <template slot-scope="scope">
            {{setState(scope.row.obj.obj.caseState)}}
          </template>
        </el-table-column>
      </el-table>
      <p style="margin-top: 20px;">
        <span style="margin-right: 20px;" v-for="item in detailLists" v-if="item.obj.feelst">{{item.obj.incidentTypeStr}}：<span
            class="red">{{item.obj.feelst.length == 0 ? 0 :item.obj.feelst[0].totalFee}}元</span></span>
      </p>
      <el-button style="margin-top: 20px;" type="primary" @click='getDown()'>下载</el-button>
      <div style="text-align: center;margin-top: 20px;">
        <el-button @click='centerDialogVisible=false'>取消</el-button>
        <el-button class='popBtn' type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import constants from '@/util/constants.js';
  import { getCasedetail,caseProgress,getNodeDataRegulator,listBiddin } from '@/views/axios/api.js'
  export default {
    data() {
      return {
        caseid:'',
        selsectList: [],
        select: '',
        centerDialogVisible: false,
        token: JSON.parse(window.localStorage.getItem("data")).data,
        status2: [
          '未启动救援',
          '等待启动授权',
          '启动授权通过，待转交救援机构报价',
          '等待救援公司报价中',
          '已转交报价，等待监管授权',
          '报价授权通过，请开始救援',
          '开始救援中',
          '救援完成待确认',
          '救援完成',
          '分公司拒绝派单', //形式
          '总司调处拒绝派单',
          '等待分公司调处确认',
          '等待总公司调处确认',
          '进入正常流程，等待海外代表接入，或直接接单等后续流程',
          '星使服务'
        ],
        mongeyObj: {},
        shijiMoney: {},
        afterMoney: {},
        expands:[],
        getRowKeys(row) {
          return row.obj.obj.id;
        }
      }
    },
    props: [
      'detailLists',
      'detailList',
      'detailsTypeName'
    ],
    mounted() {
      this.selsectList = JSON.parse(localStorage.getItem('selectList'))
      console.log(this.selsectList);
      // console.log(this.detailsTypeName)
    },
    methods: {
      timeToStr(time1,time2,state) { //时间转换
        var date3='';
        if(state == 110 || state == 111){
          date3 = time1 - time2;
        }else{
          date3 =(new Date()).getTime() - time2
        }
        //计算出相差天数
        var days = Math.floor(date3 / (24 * 3600 * 1000));
        //计算出小时数
        var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
        var hours = Math.floor(leave1 / (3600 * 1000));
        var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
        var minutes = Math.floor(leave2 / (60 * 1000));
        var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
        var seconds = Math.round(leave3 / 1000);
        //		      return days + "天 " + hours + "小时 " + minutes + " 分钟";
        return days + "天 " + hours + "小时 ";
      },
      toggleRowExpansion(row) {
        this.caseid = row.obj.obj.incidentType
        console.log(row);
        this.expands = [];
        this.expands.push(row.obj.obj.id)
        this.getData(row.obj.obj.id)
      },
      setTxt(str, status) {
        if (constants.setTxt(str, status)) {
          return constants.setTxt(str, status);
        } else {
          return str;
        }
      },
      setTime(str) {
        return constants.time(str)
      },
      toPath() {
        if (this.detailLists.length >= 6) return this.$message.error('创立的关联案件不能大于6个')
        if (this.select == '') return this.$message.error('请选择要创建的案件类型')
        if (this.select != 600 && this.select != 800) {
          this.$router.push({
            path: '/cmd_center/caseindex/appcase',
            name: 'appcase',
            query: {
              typeId: this.select,
              creat: 1,
            },
            params: {
              caseList: this.detailList.obj
            }
          })
        }else if(this.select == 800) {
          this.$router.push({
            path: '/cmd_center/caseindex/appcase',
            name: 'appcase',
            query: {
              typeId: this.select,
              creat: 1,
              type:'A'
            },
            params: {
              caseList: this.detailList.obj
            }
          })
        } else {
          this.$router.push({
            path: '/branch/starindex/newstar',
            name: 'newstar',
            query: {
              typeId: this.select,
              creat: 1
            },
            params: {
              caseList: this.detailList.obj
            }
          })
        }

      },
      setState(str) {
        var status = ''
        if (str == '100') {
          status = this.status2[0]
        } else if (str == '120') {
          status = this.status2[1]
        } else if (str == '130') {
          status = this.status2[2]
        } else if (str == '140') {
          status = this.status2[3]
        } else if (str == '150') {
          status = this.status2[4]
        } else if (str == '160') {
          status = this.status2[5]
        } else if (str == '180') {
          status = this.status2[6]
        } else if (str == '190') {
          status = this.status2[7]
        } else if (str == '110') {
          status = this.status2[8]
        } else if (str == '114') {
          status = this.status2[9]
        } else if (str == '115') {
          status = this.status2[10]
        } else if (str == '210') {
          status = this.status2[11]
        } else if (str == '211') {
          status = this.status2[12]
        } else if (str == '230') {
          status = this.status2[13]
        } else if (str == '80') {
          status = this.status2[14]
        }
        return status
      },
      getData(caseId) {
        var data = {
          token: this.token,
          caseId
        }
        getCasedetail(data)
          .then(res => {
            this.shijiMoney =res.data.obj.feelst.length != 0 ? res.data.obj.feelst[0] :  {};
            this.afterMoney =res.data.obj.obj.medicFee? res.data.obj.obj :  {};
          })
          .catch(err => {
            console.log(err)
          })

        getNodeDataRegulator(data)
          .then(res => {
            this.mongeyObj = res.data.obj ||  {};
          })
          .catch(err => {
            console.log(err)
          })
      },
      getDown(){
        window.location.href=`${SEVSRS}/rescue/case/export_case_fee?token=${this.token}&caseId=${this.$route.query.caseid}`
      }
    },
    watch: {
      detailLists() {
        if (this.detailLists.length == 0) return
        console.log(this.detailLists);
        this.selsectList.forEach(item1 => {
          this.detailLists.forEach(item2 => {
            if (item1.name == item2.obj.incidentTypeStr) {
              item1.disabled = true
            }
          })
        })
      }
    }
  }
</script>

<style scoped="scoped">
.area li{margin-right: 10px;}
.area div{overflow: hidden;}
.area div p{float: left;margin-right: 10px;}
.area span{color: #FF7800;}
  .jiesuan {
    overflow: hidden;
    margin: 20px 0;
    width: 100%;
  }

  .jiesuan >ul {
    overflow: hidden;
    float: left;
  }

  .jiesuan >ul >li {
    float: left;
    line-height: 40px;
  }

  .jiesuan .select {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/commonPage/details/jiesuan.vue